import { Button, Checkbox, DatePicker, Divider, Select, Skeleton, Table } from 'antd';
import API from 'API';
import React, { useEffect, useMemo, useState } from 'react'
import dayjs from "dayjs";
import TextArea from 'antd/es/input/TextArea';
import toastr from 'toastr';

const today = dayjs();

const translate = {
    study_progress: "Học tập có tiến bộ",
    no_homework: "Không làm bài tập",
    incomplete_homework: "Làm thiếu bài tập",
    unprepared_lesson: "Không thuộc bài",
    missing_books: "Quên sách vở",
    missing_supplies: "Quên đồ dùng học tập",
    late_to_school: "Đi học muộn",
    disruptive: "Mất trật tự",
    doing_private_work: "Làm việc riêng",
    uniform_violation: "Vi phạm đồng phục",
    left_seat: "Rời khỏi chỗ ngồi",
}

const columns = [
    {title: "Học sinh", key: "student", render: item => <>
    {item.user__last_name} {item.user__first_name}</>},
    {title: "Mã HS", key: "student_number", dataIndex: "student_number"},
]

export default function StudentEvaluation() {
    const [classes, setClasses] = useState([]);
    const [gettingClasses, setGettingClasses] = useState(true);
    const [selectedClass, setSelectedClass] = useState(null);
    const [selectedDate, setSelectedDate] = useState(today);
    const [students, setStudents] = useState([]);
    const [gettingStudents, setGettingStudents] = useState(true);
    const [updating, setUpdating] = useState(false);

    useEffect(() => {
        setGettingClasses(true);
        API.get("/classes/")
            .then(res => {
                setClasses(res.data.results);
                if (res.data.results.length > 0) {
                    setSelectedClass(res.data.results[0]);
                }
                setGettingClasses(false);
            })
            .catch(error => {
                console.log(error);
            })
    }, []);

    useEffect(() => {
        if (!selectedClass) return;
        setGettingStudents(true);
        API.get("evaluation-list/", { params: {
            date: selectedDate.format("YYYY-MM-DD"),
            class_id: selectedClass.id,
        } })
        .then(res => {
            for (const student of res.data) {
                for (const key in translate) {
                    if (student[key] === null) {
                        student[key] = false;
                    }
                }
                if (student.notes === null) {
                    student.notes = "";
                }
            }
            console.log(res.data);
            setStudents(res.data);
            setGettingStudents(false);
        })
        .catch(error => {
            console.log(error);
        })
        .finally(() => {

        })
    },[selectedDate, selectedClass])

    const columnsWithEvaluation = useMemo(() => {
        const result = [...columns]
        for (const key in translate) {
            result.push({
                title: translate[key], key: key, dataIndex: key, render: (item, record) => <>
                    <Checkbox
                        checked={item}
                        onChange={e => {
                            setStudents(students => students.map(
                                student => student.id === record.id ? {
                                    ...student,
                                    [key]: e.target.checked
                                } : student
                            ))
                        }}
                    />
                </>
            })
        }
        result.push({
            title: "Ghi chú", minWidth: 150, key: "notes", dataIndex: "notes", render: (item, record) => <>
                <TextArea 
                    value={item}
                    onChange={e => {
                        setStudents(students => students.map(
                            student => student.id === record.id ? {
                                ...student,
                                notes: e.target.value
                            } : student
                        ))
                    }}
                />
            </>
        })
        return result;
    },[])
    
    return gettingClasses ? <Skeleton active /> : <>
        <div style={{color: "green"}}>
            <b>Đánh giá sẽ được gửi đến phụ huynh vào lúc 19:00 mỗi ngày.</b>
        </div>
        <Select
            style={{ width: "100%" }}
            options={classes.map(item => ({ label: `${item.name} - ${item.year}`, value: item.id }))}
            value={selectedClass?.id}
            onChange={value => setSelectedClass(classes.find(item => item.id === value))}
        />
        <Divider />
        {classes.length === 0 && <i>Giáo viên chưa có lớp</i>}
        {selectedClass && <>
            <div>
                <b>Chọn ngày:</b> <DatePicker
                    value={selectedDate}
                    onChange={setSelectedDate}
                    disabled={gettingStudents}
                    loading={gettingStudents}
                />
                <Button loading={updating} disabled={updating} type="primary" style={{ marginLeft: 3 }} onClick={() => {
                    setUpdating(true);
                    API.post("evaluation-list/", {
                        date: selectedDate.format("YYYY-MM-DD"),
                        class_id: selectedClass.id,
                        students: students,
                    })
                    .then(res => {
                        toastr.success("Lưu đánh giá thành công!");
                    })
                    .catch(error => {
                        console.log(error);
                    })
                    .finally(() => {
                        setUpdating(false);
                    })
                }}>
                    Lưu
                </Button>
            </div>
        </>}
        <div style={{ overflowX: "auto" }}>
            <Table
                loading={gettingStudents}
                columns={columnsWithEvaluation}
                dataSource={students}
                pagination={false}
            />
        </div>
    </>
}
